import { render, staticRenderFns } from "./cabinet-quotation-request-card-closed.vue?vue&type=template&id=11cfb5ba&scoped=true&"
import script from "./cabinet-quotation-request-card-closed.vue?vue&type=script&lang=js&"
export * from "./cabinet-quotation-request-card-closed.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-quotation-request-card-closed.vue?vue&type=style&index=0&id=11cfb5ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cfb5ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11cfb5ba')) {
      api.createRecord('11cfb5ba', component.options)
    } else {
      api.reload('11cfb5ba', component.options)
    }
    module.hot.accept("./cabinet-quotation-request-card-closed.vue?vue&type=template&id=11cfb5ba&scoped=true&", function () {
      api.rerender('11cfb5ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/quotation-requests/parts/cabinet-quotation-request-card-closed.vue"
export default component.exports